interface EditorConfig {
  height?: number
  mode?: string
}

export const CodeMirrorEditor = {
  mounted() {
    // @ts-ignore
    const textarea = this.el as HTMLTextAreaElement
    const editorEl = document.getElementById(textarea.dataset.editorId || '')

    if (!editorEl) {
      console.error('Editor element not found')
      return
    }

    const config: EditorConfig = {
      height: parseInt(textarea.dataset.height || '800', 10),
      mode: textarea.dataset.mode || 'htmlmixed',
    }

    const editor = CodeMirror(editorEl, {
      mode: config.mode,
      lineNumbers: true,
      theme: 'default',
      value: textarea.value,
      lineWrapping: true,
    })

    editor.setSize('100%', config.height)

    editor.on('change', (cm: any) => {
      textarea.value = cm.getValue()
      textarea.dispatchEvent(new Event('input', { bubbles: true }))
    })

    // Server can replace the editor contents (e.g. AI-generated text). The
    // editor_id guard ensures only the targeted editor updates, since every
    // CodeMirrorEditor hook instance receives this event.
    // @ts-ignore
    this.handleEvent('set-editor-content', (payload: { editor_id: string; content: string }) => {
      if (payload.editor_id === textarea.dataset.editorId) {
        editor.setValue(payload.content)
      }
    })

    // @ts-ignore
    this.editor = editor
  },

  // The visible editor lives in a phx-update="ignore" container, but this
  // input does not — LiveView patches can rewrite its value with stale server
  // state. The editor is the source of truth for what gets submitted.
  updated() {
    // @ts-ignore
    if (this.editor) {
      // @ts-ignore
      this.el.value = this.editor.getValue()
    }
  },

  destroyed() {
    // @ts-ignore
    if (this.editor) {
      // @ts-ignore
      delete this.editor
    }
  },
}

// TODO(kacper): type it proper
// TODO(kacper): either setup WYSWIG or use it properly form npm
